import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let storySwiperWr = document.querySelectorAll('.story-swiper-wr');

storySwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let resizeFrame = null;

    const updateSlidesState = () => {
      let slides = swiperEl.querySelectorAll('.swiper-slide');
      let slideWidth = slides[0]?.offsetWidth || 0;
      let halfSlideWidth = `${slideWidth / 2}px`;

      slides.forEach((slide) => {
        slide.style.setProperty('--story-slide-half-width', halfSlideWidth);
      });

      wrapper.scrollWidth <= wrapper.clientWidth
        ? wrapper.classList.add('justify-center')
        : wrapper.classList.remove('justify-center');
    };

    const scheduleSlidesStateUpdate = () => {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = requestAnimationFrame(() => {
        updateSlidesState();
        resizeFrame = null;
      });
    };

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 0,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        641: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on: {
        afterInit: function () {
          scheduleSlidesStateUpdate();
        },

        resize: function () {
          scheduleSlidesStateUpdate();
        },
      },
    });
    swiperObserver(swiper);
  }
});
